import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

import { ref, withDefaults } from 'vue';
import { AtomButton, ColumnsIcon } from '@/components/atoms';
import { watch } from 'vue';

interface IProps {
  modelValue?: any;
  title: string;
  iconComponent?: any;
  items: { label: string; value: string }[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomMenuPopover',
  props: {
    modelValue: { default: [] },
    title: { default: '' },
    iconComponent: { default: '' },
    items: { default: () => [] }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const internalValue = ref(props.modelValue);
const emit = __emit;

watch(
  () => props.modelValue,
  (newValue) => {
    internalValue.value = newValue;
  }
);

watch(
  () => internalValue.value,
  (newInternalValue) => {
    emit('update:modelValue', newInternalValue);
  }
);

const menu = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, {
      modelValue: menu.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((menu).value = $event)),
      "close-on-content-click": false,
      location: "bottom"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_unref(AtomButton), _mergeProps(props, {
          "prepend-icon": true,
          classes: "btn-cancel w-160",
          text: _ctx.title
        }), {
          prependIcon: _withCtx(() => [
            _createVNode(_unref(ColumnsIcon))
          ]),
          _: 2
        }, 1040, ["text"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, { "min-width": "240" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
              return (_openBlock(), _createBlock(_component_v_checkbox, {
                modelValue: internalValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["modelValue", "label", "value"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})